import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openDataPlatformSubmenu } from '../sidebarHelpers';

const exploreProducts = (baseUrl, navigate, product, user) => {
  return {
    id: 'exploreProducts',
    title: 'Explore Products',
    steps: [
      {
        selector: '[data-tour="dataPlatformLink"]',
        content: <p>Click on the "Data Platform" menu item in the navigation.</p>,
      },
      {
        actionBefore: async () => {
          await openDataPlatformSubmenu('[data-tour="productsLink"]');
          navigate(`${baseUrl}/guide`, true);
        },
        selector: '[data-tour="productsLink"]',
        content: (
          <>
            <p>All products in your shop are automatically synced to Releva during the initial installation.</p>
            <p>
              After that, the full catalog is synced every 24 hours and particular products are synced once you make
              changes to them or they run out of stock.
            </p>
          </>
        ),
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/products`, true);
        },
        selector: '[data-tour="selectProduct"]',
        content: <p>Select a product.</p>,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/products/${product.id}`, true),
        selector: '[data-tour="productItem"]',
        content: <p>Each product is synced with all their information like price, name, category, discounts, etc.</p>,
        stepInteraction: true,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/products/${product.id}`, true),
        selector: '[data-tour="productCustomField"]',
        content: (
          <>
            <p>In the product custom field are stored all details about each product.</p>
            <p>
              These allow you to group customers based on product details like brand or size for example, or fine-tune
              the product blocks on your website based on product features.
            </p>
          </>
        ),
        stepInteraction: true,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find((a) => a.action === 'taskCompleted' && a.context.task === 'exploreProducts'),
  };
};

export default exploreProducts;
